// @ vendor
const Immutable = require('immutable');

// @ constants
const actionTypes = require('../../constants/actionTypes');
const { OKCONSENTS_RESET } = require('gdpr-consents/constants/actionTypes');

function setInitialState() {
    return Immutable.fromJS({
        valid: false,
        loading: false,
        hasSignaturePattern: true,
        confirmFundsFromFundsWithMoney: false,
        confirmFundsFromFundsWithMoneyLoading: false,
        confirmFundsFromFundsWithMoneyError: false,
        confirmFundsFromFundsWithMoneyData: null,
        portfolioOrderValidationOutputEmpty: false,
        skipLeaveTransferMoney: false,
        validFromAPI: false,
        resetConsents: false,
    });
}

function validateStep(step) {
    return step.merge({
        valid: true,
        loading: false,
    });
}

function cmWalletBuyStep3(state = setInitialState(), action) {
    switch (action.type) {
        case actionTypes.CM_TRANSFER_MONEY_VALIDATE_STEP:
        case actionTypes.CM_FROM_FUNDS_VALIDATE_STEP:
        case actionTypes.CM_VALIDATE_STEP:
            return validateStep(state);
        case actionTypes.CM_VALIDATE_REQUEST:
            return state.set('loading', true);
        case actionTypes.CM_VALIDATE_SUCCESS:
            return state.merge({ validFromAPI: true, loading: false });
        case actionTypes.CM_VALIDATE_FAILURE:
            return state.merge({ validFromAPI: false, loading: false });
        case actionTypes.CM_RUN_ORCHESTRATOR_SERVICE_REQUEST:
            return state.merge({
                confirmFundsFromFundsWithMoneyLoading: true,
            });
        case actionTypes.CM_RUN_ORCHESTRATOR_SERVICE_SUCCESS:
            const emptyLiquidityOrders =
                action.payload.data.portfolioOrderValidationOutput
                    .validOrderResultOutputOk.length === 0;
            const emptyFundsOrders =
                action.payload.data.portfolioTransferConfirmationOutput
                    .transferOrderResultOkOutput.length === 0;
            return state.merge({
                confirmFundsFromFundsWithMoney: !emptyFundsOrders,
                confirmFundsFromFundsWithMoneyLoading: false,
                confirmFundsFromFundsWithMoneyData: action.payload.data,
                portfolioOrderValidationOutputEmpty: emptyLiquidityOrders,
            });
        case actionTypes.CM_RUN_ORCHESTRATOR_SERVICE_FAILURE:
            return state.merge({
                confirmFundsFromFundsWithMoneyError: true,
                confirmFundsFromFundsWithMoneyLoading: false,
            });
        case actionTypes.CM_LEAVE_TRANSFER_MONEY_TO_OTHER_PAGE_CONFIRMED:
            return state.merge({
                skipLeaveTransferMoney: true,
            });
        case OKCONSENTS_RESET:
            return state.set('resetConsents', true);
        case actionTypes.CM_RESET_STEP:
            return setInitialState();
        default:
            return state;
    }
}

module.exports = cmWalletBuyStep3;
